import './GoldenStrip.css';

function GoldenStrip({ className = '' }) {
  return <div className={`golden-strip ${className}`}></div>;
}

export default GoldenStrip;
